@if (title.draw) {
  <svg:g [style.transform]="transform">
    <svg:text class="title" [style.textAnchor]="textAnchor">
      {{ title.text }}
      </svg:text>
      </svg:g>
    }
